import BlueEye from "../../components/assets/eyes/BlueEye";
import PinkEye from "../../components/assets/eyes/PinkEye";
import Heading from "../../components/layout/Heading";

function PolicyPart(
    {
        index,
        title,
        subtitle,
        children
    }
) {
    return (
        <div className="flex flex-col gap-[2.375rem]">
            <h3 className="text-heading-2 font-bold leading-[100%] mobile:text-heading-3">
                {index}. {title}
            </h3>
            <div className="flex flex-col gap-[1.25rem]">
                <h4 className="text-large font-[600]">
                    {subtitle}
                </h4>
                <div className="flex flex-col gap-[1.25rem]">
                    {children}
                </div>
            </div>
        </div>
    )
}
export default function Policy() {
    return (
        <>
            <div className="w-full max-w-[1470px] mx-auto min-h-[390px] flex flex-col justify-center mobile:px-8">
                <div className="w-full relative py-16 mobile:py-32">
                    <Heading
                        title="Politique de Confidentialité de ZOEIL"
                        subtitle="T’es chez ZOEIL, et ça tombe bien, on aime être clairs et transparents… surtout quand il s'agit de tes données. Ici, pas de blabla, pas de magouilles. Juste des infos sur ce qu’on fait (ou pas) avec tes précieuses données personnelles. C’est promis, on veille sur elles avec autant de soin que sur nos créations visuelles." />
                    <div className="w-[6.25rem] absolute right-0 top-0 -scale-x-[1] rotate-[10deg]">
                        <PinkEye version={1} />
                    </div>
                    <div className="w-[6.25rem] absolute left-0 bottom-0] -rotate-[10deg]">
                        <BlueEye version={3} />
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-[5.9375rem] mt-32 max-w-[1650px] mx-auto px-6">
                <PolicyPart index={1} title={"C'est quoi les données qu’on récupère ?"} subtitle={"Bon, on va pas te mentir, on collecte quelques infos sur toi (rien de flippant, t’inquiète). En gros, voici ce qu’on peut avoir :"}>
                    <ul className="list-disc pl-6">
                        <li>
                            <b>Ton nom et ton prénom : </b> Histoire de pas t'appeller "Hé toi" dans nos emails.
                        </li>
                        <li>
                            <b>Ton adresse e-mail : </b> Pour te tenir au courant de nos actus ou te répondre vite fait bien fait.
                        </li>
                        <li>
                            <b>Ton adresse postale</b> (si on bosse ensemble sur un projet physique).
                        </li>
                        <li>
                            <b>Tes préférences de navigation :</b> Les pages sur lesquelles tu traînes le plus (parce qu’on aime bien savoir ce qui t'intéresse).
                        </li>
                        <li>
                            <b>Ton adresse IP :</b>  Parce que notre site aime savoir q ui le visite (rien de perso, juste du standard).
                        </li>
                    </ul>
                </PolicyPart>
                <PolicyPart index={2} title={"Pourquoi on collecte tout ça ?"} subtitle={"T’inquiète, on ne récupère pas tes infos juste pour le fun. Tout a un but précis :"}>
                    <ul className="list-disc pl-6">
                        <li>
                            <b>Améliorer ton expérience sur notre site,</b>  pour qu’il te ressemble un peu plus (enfin, pas trop non plus, mais tu vois l’idée).
                        </li>
                        <li>
                            <b>Répondre à tes demandes ou propositions de collaborations.</b> Pas de réponse automatique ici, c’est du sur-mesure.
                        </li>
                        <li>
                            <b>T’envoyer des news qui valent vraiment le coup</b>  (on ne spamme pas, on n’a pas le temps pour ça).
                        </li>
                        <li>
                            <b>Analyser et optimiser le site :</b> Si certaines pages t’endorment, on les booste, si d’autres te captivent, on en fait plus. Simple, efficace.
                        </li>
                    </ul>
                </PolicyPart>
                <PolicyPart index={3} title={"Cookies, c’est pour toi"} subtitle={"Pas les biscuits (désolé), mais les petits fichiers qui s’installent sur ton navigateur pour mieux comprendre comment tu navigues sur notre site. En gros, ils permettent de :"}>
                    <ul className="list-disc pl-6">
                        <li>
                            <b>Analyser le trafic :</b> On regarde combien de gens passent ici, combien de temps ils restent et sur quelles pages.
                        </li>
                        <li>
                            <b>Améliorer la navigation :</b>  Si tu reviens, les cookies s’en souviennent et te facilitent la vie (c’est un peu comme des post-it numériques).
                        </li>
                        <li>
                            <b>Proposer des contenus adaptés :</b>  Genre, si tu kiffes la vidéo, on te mettra plus en avant nos projets vidéos que nos flyers, c’est tout.
                        </li>
                    </ul>
                    <p>
                        Mais t’es maître à bord ! Si t’es pas fan de ces cookies, tu peux toujours les désactiver dans les paramètres de ton navigateur. Promis, on ne t’en voudra pas… mais ça risque de rendre la navigation un peu moins fluide.
                    </p>
                </PolicyPart>
                <PolicyPart index={4} title={"Avec qui on partage ça ?"} subtitle={"On n’est pas du genre à vendre ton mail ou tes infos pour trois cacahuètes. Par contre, pour que tout tourne bien ici, on doit partager certaines données avec :"}>
                    <ul className="list-disc pl-6">
                        <li>
                            <b>Des prestataires techniques</b> (les mecs qui gèrent les serveurs et les bases de données, OVH et compagnie).
                        </li>
                        <li>
                            <b>Des outils d’analyse</b> (Google Analytics, par exemple, pour savoir si notre site se porte bien).
                        </li>
                    </ul>
                    <p>
                        Rassure-toi, on bosse avec des pros qui respectent aussi les règles du jeu. Tes données ne partiront pas en vacances aux quatre coins du monde sans ta permission.
                    </p>
                </PolicyPart>
                <PolicyPart index={5} subtitle={"Pas de panique, t’as tous les droits sur tes données, c’est ton terrain :"} title={"Et mes droits alors ?"}>
                    <ul className="list-disc pl-6">
                        <li>
                            <b>Accès :</b> Tu veux savoir quelles infos on a sur toi ? Demande, on te montre tout.
                        </li>
                        <li>
                            <b>Rectification :</b> T’as changé de mail ou tu veux corriger une info ? On s’en occupe.
                        </li>
                        <li>
                            <b>Suppression :</b> Tu veux qu’on efface toutes te s données ? Pas de souci, on peut faire ça, mais dis-nous juste pourquoi tu nous quittes, histoire qu’on améliore le service.
                        </li>
                        <li>
                            <b>Portabilité :</b> Tu veux récupérer tes données pour les emporter ailleurs ? Pas de souci, on te les envoie proprement.
                        </li>
                    </ul>
                    <p>
                        Pour exercer tout ça, il suffit de nous écrire à <a href="mailto:contact@agence-zoeil.com" className="underline">contact@zoeil.com</a>. On s’engage à te répondre rapidement et sans prise de tête.
                    </p>
                </PolicyPart>
                <PolicyPart index={6} title={"On garde tout ça combien de temps ?"} subtitle={"Tes données ne vont pas moisir chez nous. On les garde juste le temps nécessaire pour atteindre nos objectifs :"}>
                    <ul className="list-disc pl-6">
                        <li>
                            <b>Les cookies :</b> 13 mois maximum, après ils prennent la porte.
                        </li>
                        <li>
                            <b>Les infos de contact :</b> Le temps de nos échanges, ou jusqu’à ce que tu nous demandes de les supprimer.
                        </li>
                    </ul>
                </PolicyPart>
                <PolicyPart index={7} title={"Sécurité, toujours !"} subtitle={"On ne plaisante pas avec la sécurité de tes données. On fait tout pour qu’elles soient bien gardées, avec des systèmes de protection et des mises à jour régulières. On n’est pas parfaits, mais on fait de notre mieux pour éviter les mauvaises surprises."} />
                <PolicyPart index={8} title={"Modifications de la politique"} subtitle={"Bon, si on change quoi que ce soit dans cette politique, on te le dira. Tu seras pas pris par surprise, promis. En gros, reviens jeter un coup d’œil de temps en temps, juste pour être sûr(e) que tout est toujours bon pour toi."} />
                <p className="text-heading-6 font-[600]">
                    Voilà, tu sais tout sur notre gestion des données. T’as des questions ? Envoie-nous un petit mail, on est là pour te répondre. Chez ZOEIL, on ne voit pas que loin, on voit aussi très clair sur tout ce qui est confidentialité.
                </p>
            </div>
        </>
    )
}